import { BaseTool } from '../BaseTool';

export class MacroManagerTool extends BaseTool {
    id = 'MANAGE_MACROS';
    name = 'Macro Manager';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('macros');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
